export default [
// const dataSource = [
    {
        key: '1',
        receipt_no: '10001210',
        invoice_date: '2022-06-08',
        invoice_no: '1000000111',
        company: 'If You See the Key',
        status: 'Posted'    
    },
    {
        key: '2',
        receipt_no: '10001211',
        invoice_date: '2022-06-08',
        invoice_no: '1000000112',
        company: 'Chicken Salad',
        status: 'Posted'    
    },
    {
        key: '3',
        receipt_no: '10001212',
        invoice_date: '2022-06-08',
        invoice_no: '1000000113',
        company: 'himalayas',
        status: 'Posted'    
    },
    {
        key: '4',
        receipt_no: '10001213',
        invoice_date: '2022-06-08',
        invoice_no: '1000000111',
        company: 'If You See the Key',
        status: 'Posted'    
    },
    {
        key: '5',
        receipt_no: '10001214',
        invoice_date: '2022-06-08',
        invoice_no: '1000000112',
        company: 'Haro Taro',
        status: 'Posted'    
    },
    {
        key: '6',
        receipt_no: '10001215',
        invoice_date: '2022-06-08',
        invoice_no: '1000000113',
        company: 'If You See the Key',
        status: 'Posted'    
    },
  ];